module.exports = __webpack_public_path__ + "static/img/Paul-Harragon.2c2c238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-Harragon.jpg
// module id = hnNd
// module chunks = 0